module.exports = __webpack_public_path__ + "zw.bd54e200.svg";